/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        menu: {
            borderRadius: {
                value: "8px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "20px",
                            spread: "0px",
                            color: "#161B2B1F",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "2px",
                            spread: "0px",
                            color: "#0000001A",
                        },
                    ],
                    stringValue: "0px 6px 20px 0px #161B2B1F, 0px 0px 2px 0px #0000001A",
                },
                type: "shadow",
            },
            item: {
                height: {
                    value: "56px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "16px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "16px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "16px",
                    type: "dimension",
                },
                gap: {
                    value: "12px",
                    type: "dimension",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                default: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#f3f3f3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                    color: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                },
                destructive: {
                    default: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        color: {
                            value: "#921a1d",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#f3f3f3",
                            type: "color",
                        },
                        color: {
                            value: "#921a1d",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        color: {
                            value: "#921a1d",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        color: {
                            value: "#a0a2a5",
                            type: "color",
                        },
                    },
                },
                icon: {
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
